import { croppieProfile } from '../../modules/croppieProfile';

export const profilesCover = () => {
  croppieProfile();
};
